
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/meta/briefs",
      function () {
        return require("private-next-pages/meta/briefs.js");
      }
    ]);
  